class CartUpsell extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    if (!productId) return;
    this.load(productId);
  }

  async load(productId) {
    try {
      // "complementary" only has data when curated in Search & Discovery;
      // fall back to "related" (always populated) so the widget stays
      // relevant no matter which product is last added to the cart.
      let products = await this.fetchRecommendations(productId, 'complementary');
      if (!products.length) {
        products = await this.fetchRecommendations(productId, 'related');
      }
      if (!products.length) {
        this.remove();
        return;
      }
      this.render(products);
    } catch (e) {
      this.remove();
    }
  }

  async fetchRecommendations(productId, intent) {
    const res = await fetch(
      `/recommendations/products.json?product_id=${productId}&limit=4&intent=${intent}`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return (data.products || []).filter((p) => p.available).slice(0, 4);
  }

  render(products) {
    this.innerHTML = `
      <p class="cart-upsell__title">Toujours + d'amour</p>
      <div class="cart-upsell__list">
        ${products
          .map(
            (p) => `
          <a href="${p.url}" class="cart-upsell__item">
            <img src="${p.featured_image}" loading="lazy" width="90" height="90" alt="">
            <span class="cart-upsell__item-title">${p.title}</span>
            <span class="cart-upsell__item-price">${(p.price / 100).toFixed(2)} €</span>
          </a>
        `
          )
          .join('')}
      </div>`;
  }
}

customElements.define('cart-upsell', CartUpsell);
